import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export type AlertItem = {
	id: string;
	fields: {
		Title: Field<string>;
		Date: Field<string>;
		Type: Field<string>;
		Teaser: Field<string>;
		Description: Field<string>;
		LearnMore: LinkField;
		PrimaryAction: LinkField;
		SecondaryAction: LinkField;
	};
};

export type AlertFilterGroup = {
	id: string;
	fields: {
		Title: Field<string>;
		alerts: Array<AlertItem>;
		ViewAll: LinkField;
	};
};
